"use client";
export { ScrollView } from "react-native";
